import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth-store';
import { AuthGuard } from './AuthGuard';

interface AdminGuardProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

export function AdminGuard({ children, requireSuperAdmin = false }: AdminGuardProps) {
  return (
    <AuthGuard>
      <AdminRoleCheck requireSuperAdmin={requireSuperAdmin}>{children}</AdminRoleCheck>
    </AuthGuard>
  );
}

function AdminRoleCheck({
  children,
  requireSuperAdmin,
}: {
  children: React.ReactNode;
  requireSuperAdmin: boolean;
}) {
  const user = useAuthStore((state) => state.user);

  // Redirect to onboarding if not completed
  if (user && !user.onboardingCompletedAt) {
    if (!user.termsAcceptedAt) {
      return <Navigate to="/welcome/terms" replace />;
    }
    if (!user.privacyAcceptedAt) {
      return <Navigate to="/welcome/privacy" replace />;
    }
    return <Navigate to="/welcome/download" replace />;
  }

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const isSuperAdmin = user?.role === 'super_admin';

  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
